// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';

export default class PageViewCount extends WebComponent {
    constructor(props) {
        super(props);
        this.sendDataToGTM = this.sendDataToGTM.bind(this);
    }

    didMount() {
        if (cookie.get('pageViewCount')) {
            let pageViewCount = parseInt(cookie.get('pageViewCount')) + 1;
            cookie.set('pageViewCount', pageViewCount, {path: '/'});
            if (pageViewCount > 5) {
                this.sendDataToGTM('Zobrazení 5+ stránek');
            } else if (pageViewCount > 3) {
                this.sendDataToGTM('Zobrazení 3+ stránek');
            }
        } else {
            cookie.set('pageViewCount', 1, {path: '/'});
        }
    }
    sendDataToGTM(fgVarAct) {
        const self = this,
            dataLayer = window.dataLayer || [];

        dataLayer.push({
                'event': 'fgWebAnalytics',
                'fgVarCat': 'Interakce se stránkou',
                'fgVarAct': fgVarAct,
                'fgVarLbl': window.location.href
            }
        );
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/PageViewCount.js